module.exports = __webpack_public_path__ + "8ea03ff3938b97d4c768dd5bb93be176.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/call_your_elites-420.webp.png
// module id = 206
// module chunks = 0